/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { DestroyDirective } from '@shared/components/destroy-abstract/destroy.abstract';
import { filter, takeUntil } from 'rxjs/operators';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { fromEvent } from 'rxjs';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-full-iframe',
  templateUrl: './full-iframe.component.html',
  styleUrls: ['./full-iframe.component.scss']
})
export class FullIframeComponent extends DestroyDirective implements OnInit {
  /**
   * src iframe
   */
  @Input() src: SafeResourceUrl;

  /**
   * iframe title
   */
  @Input() title: string;

  /**
   * evento emesso ad ogni messaggio dell'iframe
   */
  @Output() postMessage: EventEmitter<string> = new EventEmitter<string>();

  constructor() {
    super();
  }

  ngOnInit() {
    this.listenMessages();
  }

  /**
   * avvia l'ascolto dei post message
   */
  private listenMessages(): void {
    fromEvent(window, 'message')
      .pipe(
        takeUntil(this.destroy$),
        filter((message: MessageEvent) => this.isRelevantMessage(message))
      )
      .subscribe((message: MessageEvent) => this.receiveMessage(message));
  }

  /**
   * riceve e gestisce il messaggio
   */
  private receiveMessage(message: MessageEvent): void {
    if (message && !!message.data) {
      this.postMessage.emit(message.data);
    }
  }

  /**
   * stabilisce se il messaggio è rilevante
   */
  private isRelevantMessage(message: MessageEvent): boolean {
    return (
      !message.data.source ||
      message.data.source.indexOf('angular-devtools') < 0
    );
  }
}
